import React from "react";
import themeGet from "@styled-system/theme-get";
import { Flex, FlexItem, H5, Box, Divider, Small } from "orcs-design-system";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import moment from "moment";
import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import useAIDashboards from "src/hooks/useAIDashboards";
import AIIcon from "src/components/AIContent/AI_Icon";

const DashboardLink = styled(NavLink)`
  text-decoration: none !important;
  font-size: ${themeGet("fontSizes.1")};
  padding: ${themeGet("space.s")};
  border-radius: ${themeGet("radii.2")};
  transition: ${themeGet("transition.transitionDefault")};
  color: ${themeGet("colors.bodyText")};
  display: flex;
  justify-content: space-between;

  &.active {
    background-color: ${themeGet("colors.primaryLightest")};
    color: ${themeGet("colors.primary")};
  }

  &:hover {
    background-color: ${themeGet("colors.hoverSurface")};
    color: ${themeGet("colors.primary")};
  }
`;

const AIDashboardsContent = () => {
  const workspace = useWorkspace();

  const { dashboards, loading } = useAIDashboards();

  if (loading) {
    return (
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
        p="r"
      >
        <Small color="greyMedium">Loading dashboards...</Small>
      </Flex>
    );
  }

  if (!dashboards || dashboards.length === 0) {
    return (
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
        p="r"
      >
        <Box mb="s">
          <AIIcon width={48} height={48} />
        </Box>
        <Small color="greyMedium" textAlign="center">
          No AI-generated dashboards yet. Ask the AI to create a dashboard in a
          chat!
        </Small>
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" height="100%">
      <FlexItem>
        <Box mb="r">
          <Flex alignItems="center" gap="xs">
            <AIIcon width={20} height={20} />

            <H5 fontWeight="bold" data-testid="heading">
              Dashboards
            </H5>
          </Flex>

          <Box my="r">
            <Divider light />
          </Box>
          <Flex flexDirection="column" gap="xs">
            {dashboards.map(({ id, title, aiChatId, createdAt }) => {
              const dashboardLink = `/${workspace.id}/dashboards/${aiChatId}/${id}`;

              return (
                <DashboardLink key={id} to={dashboardLink}>
                  <span>{title} </span>
                  <Small
                    minWidth="115px"
                    fontSize="0.75"
                    ml="auto"
                    textAlign="right"
                    color="mutedText"
                  >
                    {moment(createdAt).fromNow()}
                  </Small>
                </DashboardLink>
              );
            })}
          </Flex>
        </Box>
      </FlexItem>
    </Flex>
  );
};

export default AIDashboardsContent;
